import React from "react";
import "./Button.css";

function Button({
  isSecondary = false,
  isTertiary = false, // <-- NEW
  children,
  paddingVertical = "12px",
  paddingHorizontal = "24px",
  fontSize = "16px",
  maxWidth = "unset",
  minWidth = "unset",
  onClick,
  isDisabled = false,
  link,
  targetBlank = false,
  marginBottom = "0px",
  marginTop = "0px",
  dontShowDisabledColor = false,
  className = "", // optional: allow caller overrides
}) {
  // Resolve which variant wins if multiple are true.
  const variantClass = isTertiary ? "tertiary" : isSecondary ? "secondary" : ""; // optional (could be "")

  const baseStyle = {
    opacity: "1",
    paddingTop: paddingVertical,
    paddingBottom: paddingVertical,
    paddingLeft: paddingHorizontal,
    paddingRight: paddingHorizontal,
    fontSize,
    maxWidth,
    marginBottom,
    whiteSpace: "nowrap",
    marginTop,
    minWidth,
  };

  if (link) {
    return (
      <a
        href={link}
        target={targetBlank ? "_blank" : "_self"}
        rel={targetBlank ? "noopener noreferrer" : undefined}
        className={`transition Button ${variantClass} ${className}`.trim()}
        onClick={onClick}
        style={baseStyle}
      >
        <span>{children}</span>
      </a>
    );
  }

  return (
    <button
      disabled={isDisabled}
      className={`transition Button ${variantClass} ${
        isDisabled && !dontShowDisabledColor ? "disabled" : ""
      } ${className}`.trim()}
      style={{
        ...baseStyle,
        // For the <button> case you originally used shorthand padding; keep if you prefer:
        padding: `${paddingVertical} ${paddingHorizontal}`,
      }}
      onClick={onClick}
    >
      <span>{children}</span>
    </button>
  );
}

export default Button;
